import type { ITopCompaniesQueryFactory } from "./types";

const TOP_COMPANIES_QUERY_KEY = "top-companies-query-key";
const TOP_COMPANIES_OPPORTUNITY_SPOTTED_QUERY_KEY = "top-companies-query-key:opportunity-spotted";

export const topCompaniesQueryKeys: ITopCompaniesQueryFactory = {
    companiesList(): readonly string[] {
        return [TOP_COMPANIES_QUERY_KEY];
    },
    opportunitySpotted(domain: readonly string[]): readonly string[] {
        return [TOP_COMPANIES_OPPORTUNITY_SPOTTED_QUERY_KEY, ...domain];
    },
};
